import { createContext, useContext, useEffect, useState } from 'react';
import {
  getFingertipsLinks,
  getHealthSnapshot,
  getHealthSnapshotCoveredMembersHw,
  getSavingsSnapshot,
  getOtherCompanyBenefits,
} from '../services/dashboard';
import { getAllCompanies } from '../services/pensionIndex';
import { AuthStore } from './auth';

export type AreDashboardState = {
  healthSnapshot: Array<any>;
  fingertipLinks: Array<any>;
  companiesMessages: Array<any>;
  savingsSnapshot: Array<any>;
  coveredFamilyMembers: Array<any>;
  otherCompanyBenefits: Array<any>;
};

export const AreDashboardStore = createContext<AreDashboardState>({
  healthSnapshot: [],
  fingertipLinks: [],
  companiesMessages: [],
  savingsSnapshot: [],
  coveredFamilyMembers: [],
  otherCompanyBenefits: [],
});

const { Provider } = AreDashboardStore;

export const AreDashboardProvider = ({ children }: any) => {
  const [, , , selectedPersona] = useContext(AuthStore) || [];
  const [AreDashboardState, setAreDashboardState] = useState<AreDashboardState>(
    {
      healthSnapshot: [],
      fingertipLinks: [],
      companiesMessages: [],
      savingsSnapshot: [],
      coveredFamilyMembers: [],
      otherCompanyBenefits: [],
    }
  );

  useEffect(() => {
    let healthSnapshot = getHealthSnapshot();
    let fingertipLinks = getFingertipsLinks(selectedPersona);
    let companiesMessages = getAllCompanies(selectedPersona);
    let savingsSnapshot = getSavingsSnapshot();
    let coveredFamilyMembers = getHealthSnapshotCoveredMembersHw();
    let otherCompanyBenefits = getOtherCompanyBenefits();

    setAreDashboardState({
      healthSnapshot,
      fingertipLinks,
      companiesMessages,
      savingsSnapshot,
      coveredFamilyMembers,
      otherCompanyBenefits,
    });
  }, [selectedPersona]);

  return <Provider value={AreDashboardState}>{children}</Provider>;
};
